var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 44C88 43.74 87.83 43.49 87.5 43.25C78.52 36.49 73.72 24.9 75.29 13.77C75.35 13.37 75.29 13.07 75.11 12.89C74.93 12.71 74.63 12.65 74.23 12.71C63.1 14.28 51.51 9.48 44.75 0.5C44.5 0.17 44.25 0 44 0C43.75 0 43.49 0.17 43.25 0.5C36.49 9.48 24.9 14.28 13.77 12.71C13.37 12.65 13.07 12.71 12.89 12.89C12.71 13.07 12.65 13.37 12.71 13.77C14.28 24.9 9.48 36.49 0.5 43.25C0.17 43.5 0 43.75 0 44C0 44.25 0.17 44.51 0.5 44.75C9.48 51.51 14.28 63.1 12.71 74.23C12.65 74.63 12.71 74.93 12.89 75.11C13.07 75.29 13.37 75.35 13.77 75.29C24.9 73.72 36.49 78.52 43.25 87.5C43.5 87.83 43.75 88 44 88C44.25 88 44.51 87.83 44.75 87.5C51.51 78.52 63.1 73.72 74.23 75.29C74.63 75.35 74.93 75.29 75.11 75.11C75.29 74.93 75.35 74.63 75.29 74.23C73.72 63.1 78.52 51.51 87.5 44.75C87.83 44.5 88 44.25 88 44Z",
    fill: "#6D247A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/icon_12.c784a2722c884a42c412ec161a170c99.svg";
export { ForwardRef as ReactComponent };